(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gk-before-after"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sobczyk-before-after')) {
  class SobczykBeforeAfter extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.sba__range');
      if (!this.range) return;

      this.start = parseFloat(this.dataset.start) || 50;
      this.setPercent(this.range.value);

      this.range.addEventListener('input', () => this.setPercent(this.range.value));
      this.range.addEventListener('pointerdown', () => this.classList.add('is-dragging'));
      ['pointerup', 'pointercancel', 'blur'].forEach((evt) => {
        this.range.addEventListener(evt, () => this.classList.remove('is-dragging'));
      });

      if (this.dataset.hint === 'true' && typeof IntersectionObserver !== 'undefined') {
        this.playHint();
      }
    }

    setPercent(value) {
      this.style.setProperty('--sba-percent', value + '%');
    }

    playHint() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) return;

      this.range.value = 94;
      this.setPercent(94);

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            this.classList.add('is-animating');
            this.range.value = this.start;
            this.setPercent(this.start);
            setTimeout(() => this.classList.remove('is-animating'), 1000);
          });
        },
        { threshold: 0.35 }
      );

      observer.observe(this);
    }
  }

  customElements.define('sobczyk-before-after', SobczykBeforeAfter);
}

  } catch(e) { console.error(e); }
})();
})();
